import { FunctionComponent, useEffect, useState } from "react";
import { Modal, Button, Group } from "@mantine/core";
import useAccount from "@/hooks/useAccount";
import { CloseIcon } from "@/components/common/icons";
import useRequest from "@/hooks/useRequest";

const UserInvestmentInfoDialog: FunctionComponent<{
  opened: boolean;
  close: any;
  campaignId: string;
}> = ({ opened, close, campaignId }) => {
  const { address, login } = useAccount();

  const { data: oldData } = useRequest<{
    totalInvestDollarAmount: number;
    totalEarnedToken: number;
    totalBonusToken: number;
  }>(
    address && campaignId
      ? {
          function: "invest/getInvestmentInfo",
          data: {
            address,
            campaignId: 11,
          },
          header: {
            endpoint: "network",
          },
        }
      : null
  );

  const { data, mutate } = useRequest<{
    totalInvestDollarAmount: number;
    totalEarnedToken: number;
    totalBonusToken: number;
  }>(
    address && campaignId
      ? {
          function: "invest/getInvestmentInfo",
          data: {
            address,
            campaignId: parseInt(campaignId),
          },
          header: {
            endpoint: "network",
          },
        }
      : null
  );

  const totalEarnedToken =
    (data?.totalEarnedToken || 0) + (oldData?.totalEarnedToken || 0);
  const totalInvestDollarAmount =
    (data?.totalInvestDollarAmount || 0) +
    (oldData?.totalInvestDollarAmount || 0);
  const totalBonusToken =
    (data?.totalBonusToken || 0) + (oldData?.totalBonusToken || 0);

  useEffect(() => {
    if (opened) {
      mutate();
    }
  }, [opened]);

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      withCloseButton={false}
      classNames={{
        body: "py-10 px-8",
      }}
    >
      <CloseIcon
        className="absolute right-4 top-4 action"
        onClick={close}
      ></CloseIcon>
      <div className="flex flex-col items-center font-exo">
        <div className="text-2xl font-extrabold text-dark1 text-center">
          Your IDO Investment
        </div>
        <div className="mt-4 text-sm font-normal text-center">
          Once the IDO period end, you’ll have access to 10% of your invested
          amount.
        </div>
        <div className="mt-4 w-full relative">
          {!address && (
            <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center z-10">
              <Button radius="xl" size="md" onClick={login}>
                Connect Wallet
              </Button>
            </div>
          )}

          <div
            className={`px-6 py-8 bg-[#EBF3FF] rounded-lg text-center flex flex-col gap-8 w-full  ${
              address ? "" : "blur-sm"
            }`}
          >
            <div>
              <div className="text-[#639EFC] font-extrabold text-4xl">
                {totalEarnedToken || 0}
              </div>
              <div className="text-xl font-semibold text-gray1 mt-2">
                KAT token
              </div>
            </div>
            <div>
              <div className="text-[#639EFC] font-extrabold text-4xl">
                {totalInvestDollarAmount || 0}
              </div>
              <div className="text-xl font-semibold text-gray1 mt-2">
                Participating Amount
              </div>
            </div>
            {totalBonusToken ? (
              <div className="flex items-center justify-center font-bold">
                <div className="text-[#639EFC] ">+{totalBonusToken} KAT</div>
                <div className="ml-1">
                  ($
                  {((totalBonusToken * 100) / totalEarnedToken).toFixed(0)}%
                  Bonus)
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {address && (
          <Button
            className="mt-6 w-[242px] !text-base h-[56px]"
            radius="xl"
            onClick={close}
          >
            Close
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default UserInvestmentInfoDialog;
